import { Box } from '@workwhile/ui'
import React, { useMemo } from 'react'

const formatJson = (value: string) => {
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}

export const PayloadRenderer = ({ payload }: { payload: string }) => {
  const formatted = useMemo(() => formatJson(atob(payload)), [payload])

  return (
    <Box
      as="pre"
      margin={0}
      padding={3}
      style={{
        overflow: 'auto',
        maxHeight: '60vh',
        fontFamily: 'monospace',
        fontSize: 12,
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
      backgroundColor="neutrals.50"
      borderRadius="8px"
    >
      {formatted}
    </Box>
  )
}
